import { render, staticRenderFns } from "./SalesLeaveLeavesTable.vue?vue&type=template&id=4f15096c&scoped=true&"
import script from "./SalesLeaveLeavesTable.vue?vue&type=script&lang=js&"
export * from "./SalesLeaveLeavesTable.vue?vue&type=script&lang=js&"
import style0 from "./SalesLeaveLeavesTable.vue?vue&type=style&index=0&id=4f15096c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f15096c",
  null
  
)

export default component.exports